module.exports = __webpack_public_path__ + "6a18c87fc562b365c4b1373886a8de28.png";